var ListLooks;
(function (ListLooks) {
  ListLooks["Default"] = 'default';
  ListLooks["Primary"] = 'primary';
})(ListLooks || (ListLooks = {}));
export { ListLooks };